'use strict';

module.exports = require('./createLogger');